// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    flex: 1,
    justifyContent: 'center',
    padding: 30
  },
  image: {
    marginBottom: 30,
    resizeMode: 'contain',
    height: 120,
    width: '70%'
  },
  imageContainer: {
    marginBottom: 20,
    width: '100%'
  }
}));
